
import React from "react";
import { Box, Modal, Typography, Table, TableBody, TableCell, useTheme, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import { tokens } from "../../theme";


const ModalHorasExtras = ({ open, onClose, resumen }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  if (!resumen) return null;

  // Calcular total de minutos y monto
  const totalMinutos = resumen.detalle?.reduce(
    (acc, h) => acc + (h.minutos_extras || 0),
    0
  ) || 0;

  const totalHoras = Math.floor(totalMinutos / 60);
  const totalMinutosRest = totalMinutos % 60;

  const totalMonto = resumen.detalle?.reduce(
    (acc, h) => acc + Number(h.valor_extras || 0),
    0
  ) || 0;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 650,
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 4,
          maxHeight: "80vh",
          overflowY: "auto"
        }}
      >
        <Typography variant="h5" fontWeight="bold" mb={2} textAlign="center">
          Resumen de Horas Extras
        </Typography>

        <Box mb={2}>
          <Typography variant="subtitle1"><strong>Empleado:</strong> {resumen.nombre}</Typography>
          <Typography variant="subtitle1"><strong>Grupo:</strong> {resumen.grupo}</Typography>
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell><b>Fecha</b></TableCell>
                <TableCell><b>Entrada</b></TableCell>
                <TableCell><b>Salida</b></TableCell>
                <TableCell><b>Horas Extras</b></TableCell>
                <TableCell><b>Valor</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {resumen.detalle?.length > 0 ? (
                resumen.detalle.map((h, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{h.fecha}</TableCell>
                    <TableCell>{h.entrada}</TableCell>
                    <TableCell>{h.salida}</TableCell>
                    <TableCell>{h.horas_extras}</TableCell>
                    <TableCell>{Number(h.valor_extras).toLocaleString("es-PY")}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No hay registros de horas extras.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Totales */}
        {resumen.detalle?.length > 0 && (
          <Box mt={3}>
            <Typography variant="subtitle1">
              <strong>Total de Horas Extras:</strong> {totalHoras}:{totalMinutosRest}H
            </Typography>
            <Typography variant="subtitle1">
              <strong>Total Monto Calculado:</strong> {totalMonto.toLocaleString("es-PY")} Gs
            </Typography>
            {/* <Typography variant="subtitle1">
              (Observación: Los cálculos de horas extras se basan en los registros de entrada y salida proporcionados.
              Cualquier discrepancia debe ser reportada al departamento de RRHH para su revisión.
              En caso de que el monto sea 0, la Hora Extra no fue Aprovada por RRHH.)
            </Typography> */}
             <Box mt={2} p={4} bgcolor={colors.blueAccent[800]} borderRadius="4px">
                            <Typography variant="body1" color={colors.grey[100]}>
                                <strong>Observación:</strong>Los cálculos de horas extras se basan en los registros de entrada y salida proporcionados.
              Cualquier discrepancia debe ser reportada al departamento de RRHH para su revisión.
              En caso de que el monto sea 0, la Hora Extra no fue Aprovada por RRHH.
                            </Typography>
                        </Box>
          </Box>
        )}

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            variant="contained"
            color="success"
            onClick={onClose}
            sx={{ textTransform: "none" }}
          >
            Cerrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalHorasExtras;
